import React from 'react';
import LandingPage from './public/LandingPage';

const Home = () => {
  // Always show the landing/home page
  // Users can access their profile/dashboard via navbar navigation
  return <LandingPage />;
};

export default Home;
